import React from 'react';
import { Link } from 'react-router-dom';

export default function RateButton({ active = false, to = '/dashboard?tab=questions&focus=rate' }) {
  return (
    <Link to={to} className={`tab-btn${active ? ' active' : ''}`}>
      Rate
    </Link>
  );
}
